import type React from 'react'
import { cn } from '@/lib/utils'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'

interface PageLayoutProps {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  fixedHeader?: boolean
  fixedMain?: boolean
  mainClassName?: string
  headingClassName?: string
  contentClassName?: string
  searchClassName?: string
}

export function PageLayout({
  title,
  description,
  actions,
  children,
  fixedHeader = true,
  fixedMain,
  mainClassName,
  headingClassName,
  contentClassName,
  searchClassName,
}: PageLayoutProps) {
  return (
    <>
      <Header fixed={fixedHeader}>
        <Search className={searchClassName} />
        <div className='ml-auto flex shrink-0 items-center gap-2 sm:gap-4'>
          <ThemeSwitch />
          <ProfileDropdown />
        </div>
      </Header>

      <Main fixed={fixedMain} className={mainClassName}>
        <div
          className={cn(
            'mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between',
            headingClassName
          )}
        >
          <div className='min-w-0 space-y-1'>
            <h1 className='text-2xl font-bold tracking-tight'>{title}</h1>
            {description ? (
              <p className='text-muted-foreground'>{description}</p>
            ) : null}
          </div>
          {actions ? (
            <div className='flex shrink-0 flex-wrap items-center gap-2'>
              {actions}
            </div>
          ) : null}
        </div>

        <div className={contentClassName}>{children}</div>
      </Main>
    </>
  )
}
